var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 435 435",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_789_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_790_",
    d: "M277.5,105h-120c-13.807,0-25,11.192-25,25v50c0,12.313,8.903,22.538,20.621,24.609l8.977,206.477 C162.68,424.458,173.69,435,187.075,435h60.851c13.385,0,24.395-10.542,24.977-23.914l8.977-206.477 C293.597,202.538,302.5,192.313,302.5,180v-50C302.5,116.192,291.307,105,277.5,105z M232.5,370h-30v-80h30V370z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_793_",
    d: "M217.5,70c8.284,0,15-6.716,15-15V15c0-8.284-6.716-15-15-15c-8.284,0-15,6.716-15,15v40 C202.5,63.284,209.216,70,217.5,70z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_794_",
    d: "M158.277,75.778c1.746,0,3.522-0.307,5.253-0.954c7.759-2.902,11.697-11.546,8.794-19.305l-14.014-37.465 c-2.903-7.761-11.548-11.696-19.304-8.795c-7.759,2.902-11.697,11.546-8.794,19.305l14.014,37.465 C146.48,72.058,152.199,75.778,158.277,75.778z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_795_",
    d: "M295.994,9.26c-7.756-2.9-16.402,1.035-19.304,8.795L262.676,55.52 c-2.902,7.759,1.035,16.402,8.794,19.305c1.732,0.647,3.506,0.954,5.253,0.954c6.077,0,11.797-3.722,14.051-9.749l14.014-37.465 C307.69,20.806,303.753,12.162,295.994,9.26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorch);
export default __webpack_public_path__ + "static/media/torch.d65e2b90f439cf68f7682b9e481c032f.svg";
export { ForwardRef as ReactComponent };